var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1442 483L1442 511",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1442.5,
    cy: 478.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1437.99 478.19C1437.99 474.283 1441.29 471.117 1445.36 471.117C1445.94 471.117 1446.51 471.184 1447.06 471.308C1445.74 470.48 1444.19 470 1442.52 470C1437.81 470 1434 473.806 1434 478.5C1434 483.194 1437.81 487 1442.52 487C1444.81 487 1446.89 486.093 1448.43 484.62C1447.49 485.032 1446.45 485.263 1445.36 485.263C1441.29 485.263 1437.99 482.096 1437.99 478.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1451.4 477.6L1451.37 475.146L1449.54 476.719L1447.3 476.056L1448.11 478.337L1446.77 480.381L1449.1 480.218L1450.5 482.144L1451.13 479.763L1453.34 478.909L1451.4 477.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch2);
export default __webpack_public_path__ + "static/media/church_2.413d2c3f4fb2a9d346ffcf16c29d6e3f.svg";
export { ForwardRef as ReactComponent };